const ClientErrors = (props) => {
  const {message, error} = props
  console.log(message)
  if (error) {
    console.error(error)
  }
  return true
}

export default ClientErrors



// WEBPACK FOOTER //
// ./assets/js/lib/ClientErrors.jsx